
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ children }) {
  const { user, token } = useSelector((state) => state.auth);

  // Login nahi hai
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Admin ko normal dashboard par mat bhejna
  if (user?.role === 'Admin') {
    return <Navigate to="/admin" replace />;
  }

  return children;
}

export default ProtectedRoute;

